import controller from './controller';
import template from './template.html';
import './style.less';

const controllerAs = 'reportTopNavCtrl';
const bindings = {
  ngModel: '<',
  regulator: '=',
  action: '&'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/report/reportTopNav/index.js